import { staffGet, staffPost, BASES } from "./staffApi";
var V = BASES.VENDORPAY;

/**
 * VendorPay API client covering every endpoint in vendorpay/urls.py.
 */
export var vendorpayApi = {
  // Dashboards
  dashboardOverview: function (params) { return staffGet(V, "/dashboard/overview/", params); },
  dashboardVendor: function (params) { return staffGet(V, "/dashboard/vendor/", params); },

  // Orders
  listOrders: function (params) { return staffGet(V, "/orders/", params); },
  getOrder: function (ref) { return staffGet(V, "/orders/" + encodeURIComponent(ref) + "/"); },
  createOrder: function (body) { return staffPost(V, "/orders/create/", body); },
  markPaid: function (body) { return staffPost(V, "/orders/mark-paid/", body); },
  verify: function (body) { return staffPost(V, "/orders/verify/", body); },
  fulfill: function (body) { return staffPost(V, "/orders/fulfill/", body); },
  cancelOrder: function (body) { return staffPost(V, "/orders/cancel/", body); },
  override: function (body) { return staffPost(V, "/orders/override/", body); },
  printOrder: function (body) { return staffPost(V, "/orders/print/", body); },
  scanOrder: function (body) { return staffPost(V, "/orders/scan/", body); },

  // Vendors
  listVendors: function (params) { return staffGet(V, "/vendors/", params); },
  upsertVendor: function (body) { return staffPost(V, "/vendors/upsert/", body); },
  gstVerify: function (body) { return staffPost(V, "/vendors/gst-verify/", body); },
  onboardFromGst: function (body) { return staffPost(V, "/vendors/onboard-from-gst/", body); },
  notifyOrder: function (body) { return staffPost(V, "/orders/notify/", body); },

  // Stalls
  listStalls: function (params) { return staffGet(V, "/stalls/", params); },
  upsertStall: function (body) { return staffPost(V, "/stalls/upsert/", body); },
  generateStallQr: function (pk) { return staffPost(V, "/stalls/" + pk + "/generate-qr/", {}); },

  // Operators
  listOperators: function (params) { return staffGet(V, "/operators/", params); },
  upsertOperator: function (body) { return staffPost(V, "/operators/upsert/", body); },
  generateOperatorQr: function (pk) { return staffPost(V, "/operators/" + pk + "/generate-qr/", {}); },

  // Items
  listItems: function (params) { return staffGet(V, "/items/", params); },
  upsertItem: function (body) { return staffPost(V, "/items/upsert/", body); },

  // Stock
  listStock: function (params) { return staffGet(V, "/stock/", params); },
  loadStock: function (body) { return staffPost(V, "/stock/load/", body); },
  adjustStock: function (body) { return staffPost(V, "/stock/adjust/", body); },
  stockLog: function (params) { return staffGet(V, "/stock/log/", params); },

  // Settlements
  listSettlements: function (params) { return staffGet(V, "/settlements/", params); },
  buildSettlement: function (body) { return staffPost(V, "/settlements/build/", body); },
  approveSettlement: function (body) { return staffPost(V, "/settlements/approve/", body); },
  markSettlementPaid: function (body) { return staffPost(V, "/settlements/mark-paid/", body); }
};
